var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sidebar-wrapper" } }, [
    _c(
      "ul",
      {
        staticClass: "sidebar-nav nav-pills nav-stacked",
        attrs: { id: "menu" }
      },
      [
        void 0,
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_home" }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_home" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "home_list_slider" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { name: "ListSlider", params: { type: "home" } }
                        }
                      },
                      [_vm._v("Home Slider")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_benefit" }
          },
          [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                attrs: { id: "ul_benefits" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "benefits" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { path: "/backend/listbenefits" } } },
                      [_vm._v(" View Benefits ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "draggable_benefits" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { path: "/backend/listdraggablebenefits" }
                        }
                      },
                      [_vm._v(" Draggable Benefits List ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "benefit_type" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { path: "/backend/listbenefittypes" } } },
                      [_vm._v(" View Benefit Types ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "benefit_provider" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { to: { path: "/backend/listbenefitproviders" } }
                      },
                      [_vm._v(" View Benefit Providers ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "benefit_video" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { path: "/backend/listbenefitvideos" } } },
                      [_vm._v(" View Benefit Videos ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "benefit_site" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { path: "/backend/listbenefitsite" } } },
                      [_vm._v(" View Benefit Sites ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "benefit_glance" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListBenefitGlance" } } },
                      [_vm._v(" View Benefit Glance ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "benefit_slider" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "ListSlider",
                            params: { type: "benefit" }
                          }
                        }
                      },
                      [_vm._v("Benefit Slider")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "benefit_glance" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListBenefitSupports" } } },
                      [_vm._v(" View Benefit Supports")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "benefit_communications" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListBenefitCommunications" } } },
                      [_vm._v(" View Benefit Communications")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_event" }
          },
          [
            _c("router-link", { attrs: { to: { name: "ListEvent" } } }, [
              _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
                _c("i", { staticClass: "fa fa-calendar fa-stack-1x " })
              ]),
              _vm._v("Events")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.roleId <= 1 ||
                  _vm.userPermissions.indexOf("allow_user_management_module") >
                    -1,
                expression:
                  "roleId <= 1 || userPermissions.indexOf('allow_user_management_module') > -1"
              }
            ],
            attrs: { id: "li_user" }
          },
          [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_user" }
              },
              [
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.roleId <= 1 ||
                          _vm.userPermissions.indexOf(
                            "allow_user_management_module"
                          ) > -1,
                        expression:
                          "roleId <= 1 || userPermissions.indexOf('allow_user_management_module') > -1"
                      }
                    ],
                    attrs: { id: "user" }
                  },
                  [
                    _c("router-link", { attrs: { to: { name: "ListUser" } } }, [
                      _vm._v(" Registered Users")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.roleId <= 1 ||
                          _vm.userPermissions.indexOf(
                            "allow_user_management_module"
                          ) > -1,
                        expression:
                          "roleId <= 1 || userPermissions.indexOf('allow_user_management_module') > -1"
                      }
                    ],
                    attrs: { id: "not_registered_user" }
                  },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListNotRegisteredUser" } } },
                      [_vm._v(" New Users")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.roleId <= 1 ||
                          _vm.userPermissions.indexOf(
                            "allow_user_management_module"
                          ) > -1,
                        expression:
                          "roleId <= 1 || userPermissions.indexOf('allow_user_management_module') > -1"
                      }
                    ],
                    attrs: { id: "notification" }
                  },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListNotification" } } },
                      [_vm._v(" Notifications")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.roleId <= 0 ||
                  _vm.userPermissions.indexOf("add_contact_extension") > -1,
                expression:
                  "roleId <= 0 || userPermissions.indexOf('add_contact_extension') > -1"
              }
            ],
            attrs: { id: "li_contact_extension" }
          },
          [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_user" }
              },
              [
                [
                  _c(
                    "li",
                    { attrs: { id: "company_list" } },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "CompanyList" } } },
                        [_vm._v("Company")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { attrs: { id: "location_list" } },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "LocationList" } } },
                        [_vm._v("Location")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { attrs: { id: "department_list" } },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "DepartmentsList" } } },
                        [_vm._v("Department")]
                      )
                    ],
                    1
                  )
                ],
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "location_contact_list" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "LocationListContact" } } },
                      [_vm._v("Location Contact List")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "department_contact_list" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "DepartmentListContact" } } },
                      [_vm._v("Department Contact List")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "user_contact_list" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListContact" } } },
                      [_vm._v("User Contact List")]
                    )
                  ],
                  1
                )
              ],
              2
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_gallery" }
          },
          [
            _vm._m(4),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_gallery" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "videos" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListVideos" } } },
                      [_vm._v("List Videos")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "images" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListMedia" } } },
                      [_vm._v("List Images")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "images" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ImageListForApproval" } } },
                      [_vm._v("Images For Approval")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "category_gallery" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "ListCategory",
                            params: { type: "gallery" }
                          }
                        }
                      },
                      [_vm._v("List Category")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_discount" }
          },
          [
            _c("router-link", { attrs: { to: { name: "ListDiscount" } } }, [
              _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
                _c("i", { staticClass: "fa fa-ticket fa-stack-1x " })
              ]),
              _vm._v("Employee Perks")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_wellness" }
          },
          [
            _vm._m(5),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_wellness" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "wellness" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListWellness" } } },
                      [_vm._v("List Wellness")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "wellness_slider" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "ListSlider",
                            params: { type: "wellness" }
                          }
                        }
                      },
                      [_vm._v("List Slider")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 2,
                expression: "roleId <= 2"
              }
            ],
            attrs: { id: "li_talent" }
          },
          [
            _vm._m(6),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_talent" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "ninebox" } },
                  [
                    _c("router-link", { attrs: { to: { name: "NineBox" } } }, [
                      _vm._v("9-Box")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "ninebox" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListTalentProfile" } } },
                      [_vm._v("Talent Profiles")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_leadership" }
          },
          [
            _vm._m(7),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_leadership" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "leadership" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListLeadershipDevelopment" } } },
                      [_vm._v("List")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "category_leadership" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "ListCategory",
                            params: { type: "leadership" }
                          }
                        }
                      },
                      [_vm._v("Categories")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_dayforce" }
          },
          [
            _vm._m(8),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_dayforce" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "dayforce" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListDayforce101" } } },
                      [_vm._v("List")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "category_dayforce" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "ListCategory",
                            params: { type: "dayforce" }
                          }
                        }
                      },
                      [_vm._v("Categories")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "dayforce_doc" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListDayforce101Docs" } } },
                      [_vm._v("List Documents")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "dayforce_block_list" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "BlockListViewDayforceDoc" } } },
                      [_vm._v("Draggable List")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_401k" }
          },
          [
            _vm._m(9),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_401k" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "update_401k" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ViewUpdate401k" } } },
                      [_vm._v("401K")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "video_401k" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "List401kVideos" } } },
                      [_vm._v("401K Videos")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "slider_401k" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { name: "ListSlider", params: { type: "401k" } }
                        }
                      },
                      [_vm._v("401K Slider")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "category_401k" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { name: "ListCategory", params: { type: "401k" } }
                        }
                      },
                      [_vm._v("List Category")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_policies" }
          },
          [
            _vm._m(10),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_policies" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "policies" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListPoliciesAndForms" } } },
                      [_vm._v("List")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "policies_block_list" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "BlockListViewPoliciesForms" } } },
                      [_vm._v("Draggable List")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_survey" }
          },
          [
            _vm._m(11),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_survey" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "survey" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListSurveys" } } },
                      [_vm._v("List")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "survey_block_list" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "BlockListViewSurveys" } } },
                      [_vm._v("Draggable List")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_survey" }
          },
          [
            _vm._m(12),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_erg" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "ergs" } },
                  [
                    _c("router-link", { attrs: { to: { name: "ListERGs" } } }, [
                      _vm._v("List")
                    ])
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_FAQ" }
          },
          [
            _c("router-link", { attrs: { to: { name: "DraggableListFAQ" } } }, [
              _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
                _c("i", { staticClass: "fa fa-question-circle fa-stack-1x " })
              ]),
              _vm._v("FAQs")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_contacthr" }
          },
          [
            _c("router-link", { attrs: { to: { name: "UpdateContactHR" } } }, [
              _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
                _c("i", { staticClass: "fa fa-phone fa-stack-1x " })
              ]),
              _vm._v("Contact HR")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.roleId <= 1,
                expression: "roleId <= 1"
              }
            ],
            attrs: { id: "li_contacthr" }
          },
          [
            _c("router-link", { attrs: { to: { name: "ListArchived" } } }, [
              _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
                _c("i", { staticClass: "fa fa-archive fa-stack-1x " })
              ]),
              _vm._v("Archived Documents")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.roleId <= 0 ||
                  _vm.userPermissions.indexOf("allow_forum_module") > -1,
                expression:
                  "roleId <= 0 || userPermissions.indexOf('allow_forum_module') > -1"
              }
            ],
            attrs: { id: "li_survey" }
          },
          [
            _vm._m(13),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_survey" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "Questions" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListForumQuestions" } } },
                      [_vm._v("Posts")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "comments" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListForumComments" } } },
                      [_vm._v("comments")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.userPermissions.indexOf("allow_manager_tool_box") > -1,
                expression:
                  "userPermissions.indexOf('allow_manager_tool_box') > -1"
              }
            ],
            attrs: { id: "li_manager_tool_box" }
          },
          [
            _vm._m(14),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav nav-list tree",
                staticStyle: { display: "none" },
                attrs: { id: "ul_manager_tool_box" }
              },
              [
                _c(
                  "li",
                  { attrs: { id: "timeline" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListFolder" } } },
                      [_vm._v("Folder")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { attrs: { id: "timeline" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "ListManagerToolBox" } } },
                      [_vm._v("Documents")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-home fa-stack-1x " })
      ]),
      _vm._v(" Home "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-clock-o fa-stack-1x " })
      ]),
      _vm._v(" Benefits "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-users fa-stack-1x " })
      ]),
      _vm._v(" Users "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-folder-open-o fa-stack-1x " })
      ]),
      _vm._v(" Extension Directory "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-picture-o fa-stack-1x " })
      ]),
      _vm._v(" Gallery "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-heartbeat fa-stack-1x " })
      ]),
      _vm._v(" Wellness "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", {
          staticClass: "fa fa-star-half-o fa-stack-1x",
          attrs: { "aria-hidden": "true" }
        })
      ]),
      _vm._v(" Talent Management "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-cubes fa-stack-1x " })
      ]),
      _vm._v(" Leadership Development "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-film fa-stack-1x " })
      ]),
      _vm._v(" Dayforce 101 "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-money fa-stack-1x " })
      ]),
      _vm._v(" 401K "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-file-text fa-stack-1x " })
      ]),
      _vm._v(" Policies And Forms "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-bar-chart fa-stack-1x " })
      ]),
      _vm._v(" Surveys "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-bar-chart fa-stack-1x " })
      ]),
      _vm._v(" ERG's "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-comments-o fa-stack-1x" })
      ]),
      _vm._v(" Forum "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-cogs fa-stack-1x" })
      ]),
      _vm._v(" Manager Tool Box "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0742b2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0742b2c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/partials/Sidebar.vue
// module id = null
// module chunks = 